<div>

  <div class="top-controls d-flex justify-content-between mt-4 mb-1 px-4">
    <h4>Workflows</h4>
    <button class="ml-4 main-btn" mat-flat-button (click)="openNewWorkflowModal()">
      <i class="fa fa-plus"></i>
      New Workflow
    </button>
  </div>

  <div class="row m-0">
    <div class="p-0 col-md-12">
      <dx-data-grid
        #grid
        id="gridContainer"
        class="mt-4 no-borders"
        [dataSource]="workflows"
        [rowAlternationEnabled]="true"
        [hoverStateEnabled]="true"
        [cellHintEnabled]="false"
        (onCellClick)="selectDataGridRow($event)"
        (onContentReady)="onContentReadyHandler($event)"
      >

        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-pager [showNavigationButtons]="true"></dxo-pager>
        <dxo-paging [pageSize]="12"></dxo-paging>

        <dxi-column
          [width]="20"
          [allowFiltering]="false"
          [allowSorting]="false"
        ></dxi-column>
        <dxi-column
          dataField="name"
        ></dxi-column>
        <dxi-column
          dataField="description"
        ></dxi-column>
        <dxi-column
          alignment="center"
          dataField="created_at"
          caption="Created"
          dataType="date"
        ></dxi-column>
        <dxi-column
          [width]="150"
          alignment="center"
          dataField="is_enabled"
          caption="Enabled"
          dataType="boolean"
        ></dxi-column>
        <dxi-column
          [width]="20"
          [allowFiltering]="false"
          [allowSorting]="false"
        ></dxi-column>

      </dx-data-grid>
    </div>
  </div>
</div>
